import PropTypes from "prop-types";
import { useCustomizeUIData } from "../Provider";
import { SectionDisplayView } from "./SectionDisplayView";

export const SectionDisplay = ({ ...rest }) => {
  const { currentSection } = useCustomizeUIData();
  return <SectionDisplayView currentSection={currentSection} {...rest} />;
};

SectionDisplay.propTypes = {
  section: PropTypes.string.isRequired,
  className: PropTypes.string,
  children: PropTypes.node,
};
